/**
 * Asset Locations API
 * Handles all asset location-related API calls
 */
import apiClient from './apiClient';
import {
  AssetLocation,
  AssetLocationsListResponse,
  CreateAssetLocationData,
  UpdateAssetLocationData,
} from '../types';

export interface AssetLocationsQueryParams {
  include_inactive?: boolean;
}

export const assetLocationsApi = {
  /**
   * Get all asset locations
   */
  getLocations: async (params?: AssetLocationsQueryParams): Promise<AssetLocationsListResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.include_inactive) queryParams.append('include_inactive', 'true');

    const query = queryParams.toString();
    return apiClient.get<AssetLocationsListResponse>(`/asset-locations${query ? `?${query}` : ''}`);
  },

  /**
   * Get a specific location by ID
   */
  getLocation: async (locationId: number): Promise<{ location: AssetLocation }> => {
    return apiClient.get<{ location: AssetLocation }>(`/asset-locations/${locationId}`);
  },

  /**
   * Create a new location
   */
  createLocation: async (data: CreateAssetLocationData): Promise<{ message: string; location: AssetLocation }> => {
    return apiClient.post<{ message: string; location: AssetLocation }>('/asset-locations', data);
  },

  /**
   * Update an existing location
   */
  updateLocation: async (
    locationId: number,
    data: UpdateAssetLocationData
  ): Promise<{ message: string; location: AssetLocation }> => {
    return apiClient.put<{ message: string; location: AssetLocation }>(`/asset-locations/${locationId}`, data);
  },

  /**
   * Delete (soft delete) a location
   */
  deleteLocation: async (locationId: number): Promise<{ message: string }> => {
    return apiClient.delete<{ message: string }>(`/asset-locations/${locationId}`);
  },
};

export default assetLocationsApi;
